import {
    Component,
    Inject,
    OnInit,
    ViewEncapsulation,
    OnDestroy,
} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { fuseAnimations } from "@fuse/animations";
import { FuseTranslationLoaderService } from "@fuse/services/translation-loader.service";
import { DetalleContratistaComponent } from "../../mantenedores/contratista/detalle-contratista/detalle-contratista.component";
import { DetalleOrdenTrabajoDTO } from "../../shared/interfaces/detalle-orden-trabajo.interface";
import { DialogService } from "../../shared/services/rest/dialog.service";
import { OrdenesDeTrabajoService } from "../../shared/services/rest/ordenes-de-trabajo.service";
import { DialogAvanceTrabajoComponent } from "./components/dialog-avance-trabajo/dialog-avance-trabajo.component";
import { DialogContratistasComponent } from "./components/dialog-contratistas/dialog-contratistas.component";
import { DialogRecibirComponent } from "./components/dialog-recibir/dialog-recibir.component";
import { locale as english } from "./i18n/en";
import { locale as spanish } from "./i18n/es";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";
import { filter, finalize } from "rxjs/operators";
import { NotificacionesService } from "../../shared/services/rest/notificaciones.service";
import { DialogAnularTrabajoComponent } from "./components/dialog-anular-trabajo/dialog-anular-trabajo.component";
import { Subscription } from "rxjs";
import { DialogEvaluarComponent } from "./components/dialog-evaluar/dialog-evaluar.component";

import { DialogCorregirComponent } from "./components/dialog-corregir/dialog-corregir.component";
import { DialogPagoContratistaComponent } from "./components/dialog-pago-contratista/dialog-pago-contratista.component";
import { TrabajoService } from "../../shared/services/rest/trabajo.service";
import { PersonaDTO } from "../../shared/interfaces/persona.interface";
import { DialogPersonalApoyoComponent } from "./components/dialog-personal-apoyo/dialog-personal-apoyo.component";
import { MenuUsuarioService } from "../../shared/services/util/menu-usuario.service";
import { ArchivoService } from "../../shared/services/util/acrhivo.service";

import { DialogInvitacionesComponent } from "./components/dialog-invitaciones/dialog-invitaciones.component";

@Component({
    selector: "app-detalle-oott",
    templateUrl: "./detalle-oott.component.html",
    styleUrls: ["./detalle-oott.component.scss"],
    animations: fuseAnimations,
    encapsulation: ViewEncapsulation.None,
})
export class DetalleOOTTComponent implements OnInit, OnDestroy {
    esModal: boolean;
    idOOTT: number;
    detalleOOTT: DetalleOrdenTrabajoDTO;
    subscripciones: Subscription;
    constructor(
        private _fuseTranslationLoaderService: FuseTranslationLoaderService,
        private _dialogSrvc: DialogService,
        public dialogRef: MatDialogRef<DetalleOOTTComponent>,
        private _activatedRouteSrv: ActivatedRoute,
        @Inject(MAT_DIALOG_DATA) public data: number,
        private _ordenTrabajoSrvc: OrdenesDeTrabajoService,
        private _fuseProgressBarService: FuseProgressBarService,
        private _notificacionSrvc: NotificacionesService,
        private _trabajoSrvc: TrabajoService,
        private router: Router,
        private _menuUsuarioSrvc: MenuUsuarioService,
        private _archivoSrvc: ArchivoService
    ) {
        this.subscripciones = new Subscription();
        this._fuseTranslationLoaderService.loadTranslations(english, spanish);
        this.esModal = Object.keys(this.dialogRef).length > 0;
    }

    ngOnInit(): void {
        this.subscripciones.add(
            this._activatedRouteSrv.params.subscribe((params) => {
                if (Object.keys(params).length > 0) {
                    //console.log("entro");

                    this.idOOTT = params["idOOTT"];
                    this.getDetalleOOTT();
                }
            })
        );

        if (!Array.isArray(this.data)) {
            //console.log(this.data);
            this.idOOTT = this.data;
            this.getDetalleOOTT();
        }

        this.subscripciones.add(
            this._ordenTrabajoSrvc.refreshOOTT$
                .pipe(filter((refrescar) => refrescar))
                .subscribe((refrescar) => {
                    //console.log("refrescar", refrescar);
                    this.getDetalleOOTT();
                })
        );
    }

    getDetalleOOTT() {
        setTimeout(() => {
            this._fuseProgressBarService.show();
        });
        this.subscripciones.add(
            this._ordenTrabajoSrvc
                .fetchDetalleOrdenTrabajo(this.idOOTT)
                .pipe(finalize(() => this._fuseProgressBarService.hide()))
                .subscribe((resp) => (this.detalleOOTT = resp))
        );
    }

    verContratista(rutContratista: number) {
        //console.log(rutContratista);
        this._dialogSrvc.abrirDialog(
            DetalleContratistaComponent,
            "clase-dialog",
            "800px",
            rutContratista
        );
    }

    verAvance(event) {
        const { idTrabajo, idOOTT } = event;
        const dialogRef = this._dialogSrvc.abrirDialog(
            DialogAvanceTrabajoComponent,
            "clase-dialog",
            "800px",
            {
                idTrabajo,
                idOOTT,
            }
        );
    }

    recibirRechazar(detalleOOTT: DetalleOrdenTrabajoDTO) {
        const dialogRef = this._dialogSrvc.abrirDialog(
            DialogRecibirComponent,
            "clase-dialog",
            "800px",
            { idOOTT: detalleOOTT.idOrdenTrabajo }
        );

        dialogRef.afterClosed().subscribe((result) => {
            //console.log(result);

            if (result) {
                //abrir dialog evaluacion
                const { tieneObservaciones, comentarios } = result;
                this._fuseProgressBarService.show();
                this._ordenTrabajoSrvc
                    .recibirOOTT(
                        detalleOOTT.idOrdenTrabajo,
                        tieneObservaciones,
                        comentarios
                    )
                    .pipe(finalize(() => this._fuseProgressBarService.hide()))
                    .subscribe((resp) => {
                        //console.log(resp);
                        const msg = tieneObservaciones
                            ? "OOTT con observaciones"
                            : "OOTT recibida";
                        this._notificacionSrvc.mostrarNotificacion(
                            msg,
                            "success"
                        );
                        this.getDetalleOOTT();
                        if (
                            !tieneObservaciones &&
                            detalleOOTT.trabajo.evaluacionCliente === null
                        ) {
                            this.evaluar(detalleOOTT);
                        }
                    });
                //fetch recibir trabajo
            }
        });
    }

    corregir(idOOTT: number) {
        const dialogRef = this._dialogSrvc.abrirDialog(
            DialogCorregirComponent,
            "clase-dialog",
            "600px",
            null
        );

        dialogRef.afterClosed().subscribe((result) => {
            //console.log(result);
            if (result) {
                this._fuseProgressBarService.show();
                this._ordenTrabajoSrvc
                    .corregirOOTT(idOOTT, result.observaciones)
                    .pipe(finalize(() => this._fuseProgressBarService.hide()))
                    .subscribe((resp) => {
                        this._notificacionSrvc.mostrarNotificacion(
                            "Se ha enviado el mensaje de corrección al contratista",
                            "success"
                        );
                        this.getDetalleOOTT();
                    });
            }
        });
    }

    evaluar(event: DetalleOrdenTrabajoDTO) {
        //console.log(event);
        const dialogRef = this._dialogSrvc.abrirDialog(
            DialogEvaluarComponent,
            "clase-dialog",
            "800px",
            event,
            this._menuUsuarioSrvc.esEncargado() ? true : false
        );

        dialogRef.afterClosed().subscribe((result) => {
            //console.log(result);
            if (result) {
                this._fuseProgressBarService.show();
                this._ordenTrabajoSrvc
                    .evaluarTrabajo(this.detalleOOTT.trabajo.id, result)
                    .pipe(finalize(() => this._fuseProgressBarService.hide()))
                    .subscribe((resp) => {
                        this._notificacionSrvc.mostrarNotificacion(
                            "Contratista evaluado",
                            "success"
                        );
                        this.getDetalleOOTT();
                    });
            }
        });
    }

    anularOOTT(event) {
        const { nombreCliente, idOOTT, nombreSucursal } = event;
        const dialogRef = this._dialogSrvc.abrirDialogConfirm(
            "Anulación OOTT",
            `Favor confirme si realmente quiere realizar la anulación de la OOTT ${idOOTT} del cliente ${nombreCliente}, sucursal ${nombreSucursal}`
        );

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this._fuseProgressBarService.show();
                this._ordenTrabajoSrvc
                    .anularOOTT(idOOTT)
                    .pipe(finalize(() => this._fuseProgressBarService.hide()))
                    .subscribe((resp) => {
                        this._notificacionSrvc.mostrarNotificacion(
                            "Orden de trabajo anulada",
                            "success"
                        );
                        //refresh
                        this.getDetalleOOTT();
                    });
            }
        });
    }

    anularTrabajo(event) {
        const { idTrabajo } = event;
        const dialogRef = this._dialogSrvc.abrirDialog(
            DialogAnularTrabajoComponent,
            "clase-dialog",
            "400px",
            null
        );

        dialogRef.afterClosed().subscribe((result) => {
            //console.log(result);
            if (result) {
                this._fuseProgressBarService.show();
                this.subscripciones.add(
                    this._ordenTrabajoSrvc
                        .anularTrabajo(
                            idTrabajo,
                            result.motivo,
                            result.evaluacion
                        )
                        .pipe(
                            finalize(() => this._fuseProgressBarService.hide())
                        )
                        .subscribe((resp) => {
                            this._notificacionSrvc.mostrarNotificacion(
                                "Trabajo anulado",
                                "success"
                            );
                            this.router.navigate(["ordenes-de-trabajo"]);
                            //refresh
                            //this.getDetalleOOTT();
                        })
                );
            }
        });
    }

    abrirDialogInvitacionContratistas(event) {
        console.log(this.detalleOOTT.servicio.grupoServicio.descripcion);
        const { idOOTT, puedeAsignar } = event;
        const dialogRef = this._dialogSrvc.abrirDialog(
            DialogContratistasComponent,
            "clase-dialog",
            "100%",
            {
                idGrupoServicio: this.detalleOOTT.servicio.grupoServicio.id,
                descripcionGrupo:
                    this.detalleOOTT.servicio.grupoServicio.descripcion,
                idComuna: this.detalleOOTT.servicio.sucursal.comuna.id,
                idRegion: this.detalleOOTT.servicio.sucursal.comuna.region.id,
                idOOTT,
                puedeAsignar,
                valorCotizado: this.detalleOOTT.servicio.valorCLP,
            }
        );
    }

    informarPago(idTrabajo: number) {
        //console.log(idTrabajo);
        const dialogRef = this._dialogSrvc.abrirDialog(
            DialogPagoContratistaComponent,
            "clase-dialog",
            "350px"
        );

        dialogRef.afterClosed().subscribe((result) => {
            //console.log(result);
            if (result) {
                this._fuseProgressBarService.show();

                this._trabajoSrvc
                    .informarPago(idTrabajo, result)
                    .pipe(finalize(() => this._fuseProgressBarService.hide()))
                    .subscribe((resp) => {
                        this._notificacionSrvc.mostrarNotificacion(
                            "Pago informado",
                            "success"
                        );
                        //refresh
                        this.getDetalleOOTT();
                    });
            }
        });
    }

    verPersonalApoyo(personalApoyo: PersonaDTO) {
        //console.log(personalApoyo);

        const dialogRef = this._dialogSrvc.abrirDialog(
            DialogPersonalApoyoComponent,
            "clase-dialog",
            "600px",
            personalApoyo
        );
    }

    descargarOOTT(idOOTT: number) {
        this._ordenTrabajoSrvc.bajarPdf(idOOTT).subscribe((resp) => {
            this._archivoSrvc.descargar(resp, `OrdenTrabajo_${idOOTT}.pdf`);
        });
    }

    verInvitaciones(idOOTT) {
        console.log(event);
        const data = {
            idOOTT,
            puedeAsignar: false,
        };

        const dialogRef = this._dialogSrvc.abrirDialog(
            DialogInvitacionesComponent,
            "clase-dialog",
            "800px",
            data
        );
    }
    ngOnDestroy() {
        this.subscripciones.unsubscribe();
    }
}
